import React, { Component } from "react";
import Login from "./Login";
import WatchVideo from "./WatchVideo";
import RecordVideo from "./RecordVideo";
import ReadText from "./ReadText";
import Feedback from "./Feedback";
import Admin from "./Admin";
import logo from "./logo.svg";
import csv from "csv-generate/lib/es5";
import { app, base, firebase } from "./firebase";
import {
  Alert,
  Container,
  Row,
  Col,
  Navbar,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  Button
} from "reactstrap";
import _ from "lodash";
import FontAwesome from "react-fontawesome";
import "./_bootstrap.css";
import "./App.css";

class App extends Component {
  constructor(props) {
    super(props);

    this.components = {
      Login: Login,
      WatchVideo: WatchVideo,
      RecordVideo: RecordVideo,
      Feedback: Feedback,
      ReadText: ReadText
    };

    this.state = {
      assignments: [],
      authorizedUsers: [],
      authStatus: false,
      authToken: "",
      collectedData: {},
      currentAssignment: false,
      displayName: false,
      email: "",
      errorText: false,
      feedback: {},
      isAdmin: false,
      page: 0,
      queuedFeedbackID: false,
      showAlert: false,
      user: {},
      userVideo: "",
      videos: {}
    };

    this.advanceFeedback = this.advanceFeedback.bind(this);
    this.advanceStep = this.advanceStep.bind(this);
    this.completeAssignment = this.completeAssignment.bind(this);
    this.deleteFeedback = this.deleteFeedback.bind(this);
    this.exportFeedback = this.exportFeedback.bind(this);
    this.logIn = this.logIn.bind(this);
    this.renderStep = this.renderStep.bind(this);
    this.saveFeedback = this.saveFeedback.bind(this);
    this.setAssignment = this.setAssignment.bind(this);
    this.showAlert = this.showAlert.bind(this);
    this.toggleAdmin = this.toggleAdmin.bind(this);
    this.toggleVideoVisibility = this.toggleVideoVisibility.bind(this);
    this.updateVideoQueue = this.updateVideoQueue.bind(this);
    this.uploadVideo = this.uploadVideo.bind(this);
  }

  componentWillMount() {
    app.auth().onAuthStateChanged((user, error) => {
      console.log(user, error);

      this.authorizedState = base.fetch(`authorizedUsers`, {
        context: this,
        asArray: true,
        then(data) {
          this.setState({ authorizedUsers: data });

          if (
            user &&
            "uid" in user &&
            this.state.authorizedUsers.indexOf(user.uid) === -1
          ) {
            console.log("USER", user);
            this.showAlert("danger", `${user.email} does not have an account.`);
          } else if (
            user &&
            this.state.authorizedUsers.indexOf(user.uid) > -1
          ) {
            this.assignmentsState = base.bindToState(`assignments`, {
              context: this,
              state: "assignments",
              then: () => {
                this.userState = base.bindToState(`users/${user.uid}`, {
                  context: this,
                  state: "user",
                  showAdmin: false,
                  then: () => {
                    let stateUpdate = {
                      uid: user.uid,
                      email: user.email,
                      displayName: user.displayName,
                      authStatus: true
                    };

                    // if only one assignment, starting it
                    // if("assignments" in this.state.user && this.state.user.assignments.length === 1) {
                    this.completeAssignment(null);
                    // }

                    // capture videos from the user's cohort
                    if ("cohort" in this.state.user) {
                      this.videosState = base.bindToState(
                        `videos/${this.state.user.cohort}`,
                        {
                          context: this,
                          state: "videos",
                          asArray: true,
                          then: () => {
                            console.log("videos synced");
                            this.updateVideoQueue();
                          }
                        }
                      );
                    }

                    // if user has obama.org email, they're an admin
                    if (
                      user.email.match(
                        /^[a-zA-Z0-9_.+-]+@(?:(?:[a-zA-Z0-9-]+\.)?[a-zA-Z]+\.)?(obama)\.org$/
                      )
                    ) {
                      stateUpdate.isAdmin = true;

                      // syncing all videos
                      this.videosState = base.bindToState(`videos`, {
                        context: this,
                        state: "allVideos",
                        then: () => {
                          console.log("all videos synced");
                        }
                      });
                    } // end admin check

                    this.setState(stateUpdate);
                  }
                }); // end user sync
              }
            }); // end authorized user sync
          } else {
            if ("userState" in this) {
              base.removeBinding(this.userState);
            }
            this.setState({
              assignments: [],
              authStatus: false,
              authToken: "",
              collectedData: {},
              currentAssignment: false,
              email: "",
              feedback: {},
              isAdmin: false,
              page: 0,
              queuedFeedbackID: false,
              user: {},
              userVideo: "",
              videos: {}
            });
          }
        }
      }); // end authorizedState
    }); // end auth change
  }

  componentWillUnmount() {
    base.removeBinding(this.authorizedState);
    base.removeBinding(this.videosState);
    base.removeBinding(this.userState);
  }

  showAlert(alertType, alertText) {
    this.setState({
      alertText: alertText,
      alertType: alertType,
      showAlert: true
    });

    window.setTimeout(() => {
      this.setState({
        alertText: "",
        alertType: "",
        showAlert: false
      });
    }, 10000);
  }

  updateVideoQueue() {
    if (
      "uid" in this.state &&
      this.state.uid.length > 0 &&
      this.state.videos.length > 0
    ) {
      // ordering videos by how much feedback
      let orderedVideos = _.sortBy(this.state.videos, [
        vid => {
          return "feedback" in vid ? Object.keys(vid.feedback).length : 0;
        }
      ]);

      // removing videos you've already viewed, your own videos, and moderated videos
      let freshFeedback = _.reject(orderedVideos, vid => {
        return (
          !vid.visible ||
          ("feedback" in vid && this.state.uid in vid.feedback) ||
          this.state.uid === vid.uid
        );
      });

      if (freshFeedback.length) {
        this.setState({ queuedVideo: freshFeedback[0] });
      } else {
        this.setState({ queuedVideo: false });
      }
    }
  }

  createMarkup(text) {
    return { __html: text };
  }

  advanceFeedback() {
    let user = this.state.user;
    if ("feedbackGiven" in user) {
      user.feedbackGiven++;
    } else {
      user.feedbackGiven = 1;
    }

    this.setState({ user: user });

    if (
      user.feedbackGiven >
        this.state.assignments[this.state.currentAssignment].pages[
          this.state.page
        ].requiredFeedback ||
      this.state.queuedVideo === false
    ) {
      this.advanceStep();
    } else {
      this.updateVideoQueue();
    }
  }

  renderStep() {
    let currentAssignment = this.state.assignments[
      this.state.currentAssignment
    ];
    const currentStep = currentAssignment.pages[this.state.page];

    let { type, ...stepProps } = currentStep;

    let attributes = {
      advanceStep: this.advanceStep,
      createMarkup: this.createMarkup,
      showAlert: this.showAlert,
      ...stepProps
    };

    if (type === "Login") {
      attributes.authenticate = this.authenticate;
    }
    if (type === "RecordVideo") {
      attributes.uploadVideo = this.uploadVideo;
    }
    if (type === "Feedback") {
      if ("queuedVideo" in this.state && this.state.queuedVideo) {
        attributes.saveFeedback = this.saveFeedback;
        attributes.videoID = this.state.queuedVideo.key;
        attributes.videoURL = this.state.queuedVideo.url;
        attributes.noVideo = false;
      } else {
        attributes.noVideo = true;
      }
      //this.advanceStep();
    }

    return React.createElement(this.components[type], attributes);
  }

  deleteFeedback(cohortKey, videoKey, userKey) {
    if (window.confirm("Are you sure you want to delete this feedback?")) {
      base.remove(`videos/${cohortKey}/${videoKey}/feedback/${userKey}`);
    }
  }

  exportFeedback(cohortKey) {
    console.log("cohortKey", cohortKey);
    // let cohortKey = "boston_attendees";
    let tempObj = {};
    let finalArray = [];

    _.each(this.state.allVideos[cohortKey], (video, key) => {
      if ("feedback" in video && _.keys(video.feedback).length) {
        if (video.email in tempObj && "feedback" in tempObj[video.email]) {
          tempObj[video.email] = _.merge(tempObj[video.email], video.feedback);
        } else {
          tempObj[video.email] = video.feedback;
        }
      }
    });

    _.each(tempObj, (video, key) => {
      let mergedFeedback = "";
      _.each(video, feedback => {
        mergedFeedback += `${feedback.name} wrote:||${feedback.feedback.replace(
          /"/g,
          '\\"'
        )}||||`;
      });
      finalArray.push([key, mergedFeedback.replace(/(\r\n|\n|\r)/gm, "")]);
    });

    // let csvContent = "data:text/csv;charset=utf-8," + finalArray.join("\r\n");
    csv.stringify(finalArray, (err, output) => {
      window.open("data:text/csv;charset=utf-8," + encodeURI(output));
    });

    // console.log("feedback", finalArray.join("\r\n"));
  }

  toggleVideoVisibility(videoKey, cohortKey) {
    app
      .database()
      .ref(`videos/${cohortKey}/${videoKey}/visible`)
      .set(!this.state.allVideos[cohortKey][videoKey].visible);
  }

  advanceStep() {
    let stateUpdates = {};

    if (
      "complete" in
      this.state.assignments[this.state.currentAssignment].pages[
        this.state.page
      ]
    ) {
      this.completeAssignment(this.state.currentAssignment);
    } else {
      stateUpdates.page = this.state.page + 1;
      this.setState({ page: this.state.page + 1 });
      console.log("advanceStep", this.state.page + 1);
    }
  }

  completeAssignment(id) {
    let newState = this.state;

    let incomplete = [];

    if ("assignments" in this.state.user) {
      newState.user.assignments = this.state.user.assignments.map(a => {
        if (a.id === id) {
          a.complete = true;
        }
        if (!a.complete) {
          incomplete.push(a.id);
        }
        return a;
      });

      if (incomplete.length) {
        newState.currentAssignment = incomplete[0];
        newState.page = 0;
      }

      this.setState(newState);
    }
  }

  authenticate() {
    var provider = new firebase.auth.GoogleAuthProvider();
    provider.setCustomParameters({
      prompt: "select_account"
    });
    app
      .auth()
      .signInWithPopup(provider)
      .then(() => {
        console.log("popup done");
      });
  }

  logIn(email, password) {
    // console.log(email, password);
    app
      .auth()
      .signInWithEmailAndPassword(email, password)
      .catch(error => {
        this.showAlert("danger", error.message);
      });
  }

  logOut() {
    app
      .auth()
      .signOut()
      .then(() => {
        console.log("should be signed out");
      });
  }

  uploadVideo(url) {
    this.setState({ userVideo: url });
    base
      .push(`videos/${this.state.user.cohort}`, {
        data: {
          name: this.state.displayName,
          email: this.state.email,
          uid: this.state.uid,
          url: url,
          feedback: {},
          visible: true
        }
      })
      .then(newLocation => {
        this.advanceStep();
      });
  }

  saveFeedback(feedback) {
    // let currentVideos = this.state.videos;

    app
      .database()
      .ref(
        `videos/${this.state.user.cohort}/${feedback.videoID}/feedback/${
          this.state.uid
        }`
      )
      .set({
        name: this.state.displayName,
        email: this.state.email,
        uid: this.state.uid,
        feedback: feedback.feedbackText
      })
      .then(() => {
        this.updateVideoQueue();
        this.advanceFeedback();
      });
  }

  setAssignment(id) {
    this.setState({
      currentAssignment: id,
      page: 0
    });
  }

  toggleAdmin() {
    this.setState({
      showAdmin: !this.state.showAdmin
    });
  }

  render() {
    let step;

    if ("currentAssignment" in this.state && this.state.currentAssignment) {
      step = this.renderStep();
    }

    let assignments = "";
    if ("assignments" in this.state.user) {
      assignments = this.state.user.assignments.map(a => {
        let props = { active: false };
        if (a.id === this.state.currentAssignment) {
          props.active = true;
        }
        if (a.complete) {
          props.disabled = true;
        }
        return (
          <NavItem key={a.id}>
            <NavLink
              href="#"
              {...props}
              className={props.active ? "text-success" : "text-primary"}
              onClick={() => {
                this.setAssignment(a.id);
              }}
            >
              <FontAwesome name={a.complete ? "check-square" : "square"} />{" "}
              {this.state.assignments[a.id].name}
            </NavLink>
          </NavItem>
        );
      });
    }

    return (
      <div className="App">
        <Navbar color="light">
          <NavbarBrand>
            <img
              alt="Obama Foundation Training"
              src={logo}
              width={150}
              height={50}
            />
          </NavbarBrand>
          <Nav className="App-topnav">
            {this.state.authStatus && this.state.displayName && (
              <NavItem>
                <NavLink>
                  Hi {this.state.displayName || this.state.email}
                </NavLink>
              </NavItem>
            )}
            {this.state.isAdmin && (
              <NavItem>
                <Button color="link" onClick={this.toggleAdmin}>
                  Admin
                </Button>
              </NavItem>
            )}
            {this.state.authStatus && (
              <NavItem>
                <Button outline color="primary" onClick={this.logOut}>
                  Log out
                </Button>
              </NavItem>
            )}
          </Nav>
        </Navbar>
        <Container>
          <Row>
            <Col xs="12" sm="4" className="my-5">
              <Nav vertical>{assignments}</Nav>
            </Col>
            <Col xs="12" sm="8" className="Step-wrapper my-5 content">
              {this.state.showAdmin ? (
                <Admin
                  allVideos={this.state.allVideos}
                  deleteFeedback={this.deleteFeedback}
                  exportFeedback={this.exportFeedback}
                  toggleVideoVisibility={this.toggleVideoVisibility}
                />
              ) : (
                <div>
                  {this.state.showAlert && (
                    <Alert color={this.state.alertType}>
                      {this.state.alertText}
                    </Alert>
                  )}
                  {this.state.authStatus || (
                    <Login
                      logIn={this.logIn}
                      headline="Welcome!"
                      description="Please sign in. This is the same password you received in your acceptance email to access the welcome page."
                      authenticate={this.authenticate}
                    />
                  )}
                  {this.state.authStatus && this.state.currentAssignment && (
                    <span>{step}</span>
                  )}
                </div>
              )}
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js